import { create } from "zustand"

import { galleryItems } from "@/data/gallery"
import { unlockCollection } from "@/services/core"
import type { GalleryItem } from "@/types"
import { requireLogin, useGlobalStore } from "./global"

interface GalleryState {
    items: GalleryItem[]

    initGallery: () => void
    unlockItem: (itemId: string) => void
}

export const useGalleryStore = create<GalleryState>((set) => ({
    items: galleryItems,
    currentPage: 0,

    initGallery: () => {
        const collection = useGlobalStore.getState().player?.collection
        const galleryCollection = collection?.gallery
        if (!galleryCollection) return

        const unlockedKeys = new Set(galleryCollection.map((item) => item.key))
        set((state) => ({
            items: state.items.map((item) =>
                unlockedKeys.has(item.id) ? { ...item, unlocked: true } : item,
            ),
        }))
    },

    unlockItem: (itemId) => {
        if (!requireLogin()) return

        set((state) => ({
            items: state.items.map((item) =>
                item.id === itemId ? { ...item, unlocked: true } : item,
            ),
        }))

        const gameStartTs = useGlobalStore.getState().gameStartTs
        unlockCollection(gameStartTs, "gallery", itemId).then((res) => {
            if (res.code === 0) {
                useGlobalStore
                    .getState()
                    .updateCollectionGroup("gallery", res.data.list)
            }
        })
    },
}))
